import { intlLocale, type UiLocale } from "./config";
import { MESSAGES, type MessageKey } from "./messages";

export type TVars = Record<string, string | number>;
export type TFunction = (key: MessageKey, vars?: TVars) => string;

function lookup(locale: UiLocale, key: string): string | undefined {
  const dot = key.indexOf(".");
  const ns = key.slice(0, dot);
  const k = key.slice(dot + 1);
  const table = (MESSAGES[locale] as Record<string, Record<string, string>>)[ns];
  return table?.[k];
}

/**
 * Translate a key ("namespace.key"). Falls back to English, then to the key itself.
 * Plurals: define the base key as the general ("other") form; when vars.count is a number and
 * "<key>_<category>" exists (Intl.PluralRules: zero/one/two/few/many), that form wins. Placeholders: {name}.
 */
export function makeT(locale: UiLocale): TFunction {
  const rules = new Intl.PluralRules(intlLocale(locale));
  return (key, vars) => {
    let msg: string | undefined;
    if (vars && typeof vars.count === "number") {
      const cat = rules.select(vars.count);
      msg = lookup(locale, `${key}_${cat}`) ?? lookup(locale, key) ?? lookup("en", `${key}_${new Intl.PluralRules("en").select(vars.count)}`);
    }
    msg ??= lookup(locale, key) ?? lookup("en", key) ?? key;
    if (!vars) return msg;
    return msg.replace(/\{(\w+)\}/g, (m, name: string) => (name in vars ? String(vars[name]) : m));
  };
}
